// extracted by mini-css-extract-plugin
module.exports = {"successText":"PaymentDetail_successText__eusm_","icon":"PaymentDetail_icon__pYe9A"};